import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AlgChannelService } from "./channel.service";
import { Core2Config } from "../../../shared";

@Injectable({ providedIn: "root" })
export class InstagramFeedService extends AlgChannelService {

    constructor(httpClient: HttpClient) {
        super();
        this.apiUrl =  Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE+  'instagram-feed/';
        this.endpointPath =Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE +  'instagram-feed/';
        this.httpClient = httpClient;
    }

    sendPost(data: FormData,apiVisa){
        let apiUrl = apiVisa.api_domain_url +  this.endpointPath +  'post';
        return this.httpClient.post(apiUrl,data, this.getHeader(apiVisa))

    }

    postComment(data, apiVisa) {
        let apiUrl = apiVisa.api_domain_url +  this.endpointPath + "create/comment";
        return this.httpClient.post(apiUrl, data, this.getHeader(apiVisa));
    }

    postReplyComment(data, apiVisa) {
        let apiUrl = apiVisa.api_domain_url +  this.endpointPath + "create/reply/comment";
        return this.httpClient.post(apiUrl, data, this.getHeader(apiVisa));
    }

    setWebHook(data, apiVisa) {
        let apiUrl = apiVisa.api_domain_url +  this.endpointPath + "webhook/data";
        return this.httpClient.post(apiUrl, data, this.getHeader(apiVisa));
    }

    getHeader(apiVisa) {
        let headers = new HttpHeaders({
            'tenant-code': apiVisa.tenantCode
        })
        return { headers: headers };
    }
    
        

}
